<template>
    <component :is="this.$route.meta.letter || 'website-view'">
        <slot/>
    </component>
</template>

<script type="text/jsx">
    import Website from '@/components/templates/Website'
    export default {
        name: 'app',
        components: {
            'website-view': Website
        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?1c1c9c32